import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MenuItem, usePackContext } from "../../context/pack"; // 경로 수정
import Header from "../../../../components/common/header";
import clsx from "clsx";

const ManualEntry: React.FC = () => {
  const { addPack } = usePackContext();
  const navigate = useNavigate();

  const [menuName, setMenuName] = useState("");
  const [price, setPrice] = useState<number | string | "">("");
  const [discountRate, setDiscountRate] = useState<number | "">(50); // 할인율 추가
  const [imageFile, setImageFile] = useState<File | null>(null); // 이미지 파일로 받기
  const [isSampleMenu, setIsSampleMenu] = useState<boolean>(false); // 샘플 메뉴 상태 추가
  const discountRates = [30, 40, 50, 60]; // 사용할 할인율 목록
  const [quantity, setQuantity] = useState(1);
  const handleComplete = (e: React.FormEvent) => {
    e.preventDefault();

    if (!menuName || !price || !imageFile) {
      alert("모든 항목을 입력해주세요.");
      return;
    }

    const newMenuItem: MenuItem = {
      id: 0, // '직접입력임을 알리기 위함'
      name: menuName,
      img: imageFile, // 이미지 파일을 URL로 변환
      price: Number(price),
      discountRate: Number(discountRate),
      quantity: 1,
    };

    // 팩 추가
    addPack([newMenuItem], isSampleMenu, undefined, quantity); // isSampleMenu 반영
    navigate("/boss/live-order/upload"); // 팩 생성 페이지로 이동
  };

  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setImageFile(e.target.files[0]);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header title="직접 팩 구성하기" showBackButton />
      <div className="p-6">
        <h2 className="text-2xl font-bold mb-6">팩 직접 입력</h2>
        <form className="space-y-4">
          {/* 팩 이름 */}
          <div>
            <label
              htmlFor="menuName"
              className="block font-medium text-gray-700 mb-2"
            >
              팩 이름
            </label>
            <input
              type="text"
              id="menuName"
              value={menuName}
              onChange={(e) => setMenuName(e.target.value)}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-[#1562fc] focus:border-[#1562fc]"
            />
          </div>

          {/* 이미지 업로드 (파일 입력 + 카메라 + 갤러리 선택 가능) */}
          <div>
            <label
              htmlFor="imageUrl"
              className="block font-medium text-gray-700 mb-2"
            >
              상품 이미지
            </label>
            <input
              type="file"
              id="imageUrl"
              accept="image/*" // 이미지 파일만 선택 가능
              // capture="environment" // 모바일에서 카메라 선택 가능
              onChange={handleImageUpload}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-[#1562fc] focus:border-[#1562fc]"
            />
          </div>

          {/* 가격 */}
          <div>
            <label
              htmlFor="price"
              className="block font-medium text-gray-700 mb-2"
            >
              정가 (원)
            </label>
            <input
              type="number"
              id="price"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-[#1562fc] focus:border-[#1562fc]"
            />
          </div>

          {/* 할인율 */}
          <div className="pt-10">
            <label className="block text-2xl font-bold text-gray-700 mb-2">
              할인율 (%)
            </label>
            <div className="text-gray-500 mb-2">
              마감히어로 데이터를 분석한 결과, 50% 할인율이 가장 높은 판매율을
              보였습니다.
              <span style={{ color: "green", marginLeft: 4 }}>50%</span>를
              권장합니다!
            </div>
            <div className="flex space-x-4">
              {discountRates.map((rate) => (
                <button
                  key={rate}
                  onClick={() => setDiscountRate(rate)}
                  type="button"
                  className={clsx("px-4 py-2 border rounded-md", {
                    "bg-blue-500 text-white": discountRate === rate,
                    "bg-gray-200": discountRate !== rate,
                  })}
                >
                  {rate}%
                </button>
              ))}
            </div>
          </div>

          <div className="pt-10">
            <label className="block text-2xl font-bold mb-2">상품 유형</label>
            <div className="text-gray-500 mb-2">
              소비자에게 표시됩니다! 마감상품이 아닌데 마감상품으로 생각하면
              아쉽잖아요 😁
            </div>
            <div className="flex flex-col items-start space-y-2">
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={!isSampleMenu}
                  onChange={(e) => setIsSampleMenu(!e.target.checked)}
                  className="w-5 h-5"
                />
                마감상품
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={isSampleMenu}
                  onChange={(e) => setIsSampleMenu(e.target.checked)}
                  className="w-5 h-5"
                />
                신상품 (홍보용, 신메뉴, 프로모션, 맛보기 등)
              </label>
            </div>
          </div>

          <div className="flex flex-col justify-center w-full">
            <hr className="my-4" />
            <h3 className="text-3xl font-bold mt-4 text-gray-800">
              팩 판매 개수
            </h3>

            <span className="text-gray-500 mb-2">
              위에서 입력한 것을 총 몇 팩 판매할까요?
            </span>
            <div className="flex flex-col items-center justify-center mt-4 bg-white rounded-lg p-4">
              <div className="flex items-center justify-center">
                <button
                  type="button" // type을 button으로 설정하여 새로고침 방지
                  className="bg-gray-300 w-10 h-10 font-bold rounded-full text-2xl"
                  onClick={() => setQuantity(Math.max(1, quantity - 1))}
                >
                  -
                </button>
                <span className="mx-4 text-4xl font-bold">{quantity}개</span>
                <button
                  type="button" // type을 button으로 설정하여 새로고침 방지
                  className="bg-blue-400 w-10 h-10 font-bold rounded-full text-2xl"
                  onClick={() => setQuantity(Math.max(1, quantity + 1))}
                >
                  +
                </button>
              </div>
            </div>
          </div>

          {/* 완료 버튼 */}
          <div className="pt-6">
            <button
              onClick={handleComplete}
              className="w-full py-3 bg-[#1562fc] text-white rounded-md hover:bg-[#124ab7] transition duration-150"
            >
              완료하기
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ManualEntry;
